import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../redux/store';
import AuthForm from '../components/AuthForm';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './AuthPage.css';

const AuthPage: React.FC = () => {
  const starsRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Create stars for the background
    const createStars = () => {
      if (!starsRef.current) return;
      
      // Clear existing stars
      starsRef.current.innerHTML = '';
      
      // Create 200 stars with random positions and sizes
      for (let i = 0; i < 200; i++) {
        const star = document.createElement('div');
        star.style.position = 'absolute';
        star.style.width = `${Math.random() * 2 + 0.5}px`;
        star.style.height = star.style.width;
        star.style.background = 'white';
        star.style.borderRadius = '50%';
        star.style.top = `${Math.random() * 100}%`;
        star.style.left = `${Math.random() * 100}%`;
        star.style.opacity = `${Math.random() * 0.5 + 0.3}`;
        star.style.animation = `twinkle ${Math.random() * 3 + 2}s ease-in-out infinite`;
        star.style.animationDelay = `${Math.random() * 3}s`;
        
        starsRef.current.appendChild(star);
      }
    };
    
    createStars();
    window.addEventListener('resize', createStars);
    
    return () => {
      window.removeEventListener('resize', createStars);
    };
  }, []);

  // AuthFlow component handles all authentication logic and redirects

  return (
    <div className="auth-page">
      <div className="auth-page-stars" ref={starsRef}></div>
      <Header />
      <div className="auth-page-content">
        <AuthForm />
      </div>
      <Footer />
    </div>
  );
};

export default AuthPage;